
namespace RioERP.Orders {

    @Serenity.Decorators.registerClass()
    export class CustomerGiftCardsDialog extends Serenity.EntityDialog<CustomerGiftCardsRow, any> {
        protected getFormKey() { return CustomerGiftCardsForm.formKey; }
        protected getIdProperty() { return CustomerGiftCardsRow.idProperty; }
        protected getLocalTextPrefix() { return CustomerGiftCardsRow.localTextPrefix; }
        protected getNameProperty() { return CustomerGiftCardsRow.nameProperty; }
        protected getService() { return CustomerGiftCardsService.baseUrl; }
        protected getDeletePermission() { return CustomerGiftCardsRow.deletePermission; }
        protected getInsertPermission() { return CustomerGiftCardsRow.insertPermission; }
        protected getUpdatePermission() { return CustomerGiftCardsRow.updatePermission; }

        protected form = new CustomerGiftCardsForm(this.idPrefix);

    }
}